
import Index from "./Index";

const Home = () => {
  return <Index />;
};

export default Home;
